import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/features/Home/components/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/Home/components/RecommenderCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/Home/components/ScrollToTopButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/Insurance/InsurenceHero.tsx");
